module.exports = __webpack_public_path__ + "img/bg-seigaha.62950455.png";